<template>
  <div class="p-about">

    <div class="s-header">
      <div class="s-header-copy">
        <div class="s-header-title">
          <ul class="f-xs">
            <li>
              About
            </li>
            <li>
              <a class="l-rg p-cta" target="_blank" follow="nofollow" href="https://statestreet-icx.efrontcloud.com/StateStreet">Investor Login</a>
            </li>
          </ul>
        </div>
        <div class="s-header-head">
          <h1 class="f-xl">
            <span class="f-xl-line">Global.</span>
            <span class="f-xl-line">Long-term.</span>
            <span class="f-xl-line">Focused.</span>
          </h1>
        </div>
      </div>

      <div style="display: none">
        <div class="s-header-scroll">
          <i class="s-header-indicator"></i>
          <p class="f-xs">Scroll &amp; Discover</p>
        </div>
      </div>

      <div class="s-header-image">
        <div class="s-header-src"></div>
      </div>

      <div class="scroll-down">
        <div class="scroll-down-arrow" @click="emitEventScroll"></div>
      </div>
    </div>

    <div class="s-marquee">
      <div class="s-marquee-head">
        <h3 class="f-xs"></h3>
      </div>
      <div class="s-marquee-wrap">
        <h2 class="f-xl" style="font-size 3.2vw;">New York. London. Buenos Aires.</h2>
      </div>
    </div>

    <div class="s-text">
      <div class="s-text-wrap">
        <p class="f-md" data-animate="fade">
          VR Capital has managed external capital since 1999. We have extensive, multi-cycle knowledge of corporate and sovereign issuers across emerging and developed markets.
        </p>

        <p class="f-md" data-animate="fade">
          We seek to achieve superior risk-adjusted returns through investments in distressed securities and event-driven/special situations, with a strong focus on emerging markets. We bring integrity and discipline to our investment process.
        </p>

        <p class="f-md" data-animate="fade">
          Our clients' interests are paramount in everything we do. When their interests are served, we maximize the long-term value of our franchise.
        </p>
      </div>
    </div>

    <!--<div class="s-awards">
    <div class="s-awards-logos">
      <div
        v-for="(logo, index) in logos"
        class="s-awards-logo"
        :key="index"
      >
        <div
          class="s-awards-logo-inner"
          :style="{ backgroundImage: `url('${logo.image}')` }"
          :title="logo.title"
        >
        </div>
      </div>
    </div>
    <router-link class="p-cta" to="/disclaimer/awards">
      Awards Disclaimer
    </router-link>
  </div>

  <!-- <div class="s-text">
    <div class="s-text-head">
      <h3 class="f-xs">The Talks</h3>
      <h2 class="f-xl" data-animate="stagger">VR Cares</h2>
    </div>
    <div class="s-text-wrap">
      <p class="f-md" data-animate="fade">
        To request additional information regarding VR, please provide the information requested below and submit.
      </p>
    </div>
    <div class="s-text-footer">
      <router-link class="b-rg p-cta" to="/contact">
        Contact
        <svg class="i-arrow" viewBox="0 0 39.6 24.4" xmlns="http://www.w3.org/2000/svg">
          <polygon points="39.6 12.2 39.6 12.2 39.5 12.2 39.6 12.2 39.6 12.2 27.8 0 27.1 0.7 37.7 11.7 0 11.7 0 12.7 37.7 12.7 27.1 23.7 27.8 24.4 39.6 12.2 39.6 12.2 39.6 12.2"/>
        </svg>
      </router-link>
    </div>
  </div> -->

    <Footer />

  </div>
</template>

<script>
import { gsap } from 'gsap';
import Sniffer from 'sniffer';
import Footer from '@/components/footer/footer.vue';

export default {
  components: {
    Footer,
  },

  data() {
    return {
      logos: [
        {
          image: '/images/hfm-awards-2025.png',
          title: 'HFM Awards 2025',
        },
        {
          image: '/images/hfm-awards-2025.jpg',
          title: 'HFM Awards 2025',
        },
        {
          image: '/images/eurohedge-awards-2024.png',
          title: 'Eurohedge Awards 2024',
        },
        {
          image: '/images/hfm-awards-2024-Uk.png',
          title: 'HFM Awards 2024',
        },
        {
          image: '/images/hfm-awards-2024-US.jpg',
          title: 'HFM Awards 2024',
        },
        {
          image: '/images/eurohedge-awards-2023.png',
          title: 'Eurohedge Awards 2023',
        },
        {
          image: '/images/eurohedge-awards-2020.png',
          title: 'Eurohedge Awards 2020',
        },
        {
          image: '/images/eurohedge-awards-2018.jpg',
          title: 'Eurohedge Awards 2018',
        },
        {
          image: '/images/eurohedge-awards-2017.jpg',
          title: 'Eurohedge Awards 2017',
        },
        {
          image: '/images/eurohedge-awards-2013-1.png',
          title: 'Eurohedge Awards 2013',
        },
        {
          image: '/images/eurohedge-awards-2013-2.png',
          title: 'Eurohedge Awards 2013',
        },
        {
          image: '/images/eurohedge-awards-2010.png',
          title: 'Eurohedge Awards 2010',
        },
        {
          image: '/images/hfm-awards-2018.png',
          title: 'HFM Awards 2018',
        },
        {
          image: '/images/hfm-awards-2017.png',
          title: 'HFM Awards 2017',
        },
        {
          image: '/images/hfm-awards-2014.png',
          title: 'HFM Awards 2014',
        },
        {
          image: '/images/hfm-awards-2013.png',
          title: 'HFM Awards 2013',
        },
        {
          image: '/images/hfm-awards-2011.png',
          title: 'HFM Awards 2011',
        },
        {
          image: '/images/hfmeu-awards-2010.png',
          title: 'HFM EU Awards 2010',
        },
        {
          image: '/images/hfm-awards-2010.png',
          title: 'HFM Awards 2010',
        },
        {
          image: '/images/institutional-investor-2012.png',
          title: 'Institutional Investor Award 2012',
        },
        {
          image: '/images/institutional-investor-2011.png',
          title: 'Institutional Investor Award 2011',
        },
      ],
    };
  },

  methods: {
    emitEventScroll() {
      const scrollToEvent = new CustomEvent('customScrollTo', {
        detail: { scrollVal: window.innerHeight },
      });
      if (Sniffer.isPhone) gsap.to('.a-scroll', { duration: 1, scrollTo: window.innerHeight });

      window.dispatchEvent(scrollToEvent);
    },
  },
};
</script>
